import { DeviceFingerprintTracker } from '@core/analytics'
import { useValues } from '@core/store'
import { getCanCollectDeviceFingerprint } from '@features/cookie-consent'

type TDeviceFingerprintContainerProps = {
    userId: number
}

export const DeviceFingerprintContainer = ({ userId }: TDeviceFingerprintContainerProps) => {
    const [isEligible] = useValues([getCanCollectDeviceFingerprint])

    if (!isEligible) {
        return null
    }

    return <DeviceFingerprintTracker userId={userId} />
}
